import { TextField, Button, FormControl, Grid } from '@mui/material';
import { ArrowRightCircle, Save } from 'react-feather';

import { CustomAutocomplete, LinearLoading } from 'common'

export const GeneralInfoStep = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange, onInputNumberChange, onSelectSearchChange } = FormScreen
    
    const { 
        fetchSpecificProcessLawyer,
        fetchAllClients,
        fetchProcessType
    } = FetchData
    const { setLoadingFetchSpecificProcessLawyer } = fetchSpecificProcessLawyer
    const { dataClients } = fetchAllClients
    const { dataProcessType } = fetchProcessType

    const {
        onSubmitForm,
        handleClickContinue
    } = Actions

    const restrictEditFlag = parseInt(formState.idlawyer, 10) > 0
    
    return (
        <>
            
            <div className='h4 mt-1 mb-1'>
                {formState.idlawyer > 0
                    ? 'Actualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>
            {setLoadingFetchSpecificProcessLawyer && ( <LinearLoading /> )}

            <div className="pt-2"></div>
            <form onSubmit={onSubmitForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idcliente">* Cliente</label>
                            <CustomAutocomplete 
                                customId="idcliente"
                                customName="idcliente"
                                customValue={formState.idcliente}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcliente', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataClients.map(({ idcliente, dpi, nombre, apellido }) => ({
                                        value: idcliente,
                                        name: `${dpi} - ${nombre} ${apellido}`
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode || restrictEditFlag}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idprocesstype">* Proceso / Servicio</label>
                            <CustomAutocomplete 
                                customId="idprocesstype"
                                customName="idprocesstype"
                                customValue={formState.idprocesstype}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idprocesstype', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataProcessType.map(({ idprocesstype, name_process, category, type }) => ({
                                        value: idprocesstype,
                                        name: `${category} - ${type} - ${name_process}`
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode || restrictEditFlag}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-3"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="date_start">* Fecha</label>
                            <TextField
                                id="date_start"
                                name="date_start"
                                value={formState.date_start}
                                onChange={onInputChange}
                                size='small'
                                type="date"
                                variant="outlined"
                                hiddenLabel
                                disabled={readOnlyMode || restrictEditFlag}
                                InputProps={{
                                    readOnly: readOnlyMode || restrictEditFlag,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="initial_amount">* Costo</label>
                            <TextField
                                id="initial_amount"
                                name="initial_amount"
                                value={formState.initial_amount_mask}
                                onChange={onInputNumberChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                hiddenLabel
                                disabled={readOnlyMode || restrictEditFlag}
                                InputProps={{
                                    readOnly: readOnlyMode || restrictEditFlag,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="process_number">Número de proceso (Juzgado)</label>
                            <TextField
                                id="process_number"
                                name="process_number"
                                value={formState.process_number}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-3"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="process_ministry">Número de proceso (MP)</label>
                            <TextField
                                id="process_ministry"
                                name="process_ministry"
                                value={formState.process_ministry}
                                onChange={onInputChange}
                                // label='Marca'
                                size='small'
                                type="text"
                                variant="outlined"
                                // hiddenLabel
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="observations">Observaciones</label>
                            <TextField
                                id="observations"
                                name="observations"
                                value={formState.observations}
                                onChange={onInputChange}
                                size='small'
                                multiline
                                rows={3}
                                type="text"
                                variant="outlined"
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            {/* <Button
                                variant="contained"
                                type="submit"
                                disabled={readOnlyMode}
                                style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                            >
                                <Save />
                            </Button>
                            &nbsp; */}
                            {(formState.idlawyer > 0)&&(
                                <Button
                                    variant="contained"
                                    type="button"
                                    onClick={handleClickContinue}
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                >
                                    <ArrowRightCircle/>
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
